<div class="col-12">
  <router-outlet></router-outlet>
</div>